// Do NOT add "use client" to this file
import { jsx as _jsx } from "react/jsx-runtime";
import { ProductTileImageBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/__internal__/ProductTileImageBase";
import { PRODUCT_GRID_IMAGE_BREAKPOINTS } from "@faire/retailer-visitor-shared/views/search/const";
import React from "react";
export var ProductImage = function(param) {
    var data = param.data;
    var image = data.image, imageAltText = data.imageAltText, shouldUseLazyImageLoading = data.shouldUseLazyImageLoading, showVerticalImagery = data.showVerticalImagery, onLoad = data.onLoad;
    return /*#__PURE__*/ _jsx(ProductTileImageBase, {
        image: image,
        imageAltText: imageAltText,
        showVerticalImagery: showVerticalImagery,
        useLazyImageLoading: shouldUseLazyImageLoading,
        imageBreakpoints: PRODUCT_GRID_IMAGE_BREAKPOINTS,
        onLoad: onLoad
    });
};
